// @flow

import Organization from '../organization/organization.model.js';

export default class Invoice {
  static getListLink(pilotId: string, orgUnique: string): string {
    return `${window.serverData._uri}${
      Organization.orgAccess ? `/org/${orgUnique}/invoices/users/${pilotId}/` : '/invoices/'
    }`;
  }

  static getInvoiceLink(invoiceId: string, orgUnique: string): string {
    return `${window.serverData._uri}${
      Organization.orgAccess
        ? `/org/${orgUnique}/invoices/${invoiceId}/`
        : `/invoices/${invoiceId}/`
    }`;
  }
}
